/* import __COLOCATED_TEMPLATE__ from './fly-checkbox-dropdown.hbs.js'; */
var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { isNone } from '@ember/utils';
import { action } from '@ember/object';
import { pluralize } from 'ember-inflector';
/**
  FlyCheckboxDropdown is a dropdown where each item can be toggled on or off.
  It's similar to FlyPowerSelectMultiple in this regard, as it allows selecting many items out of a list.

  ```hbs
  <FlyCheckboxDropdown
    \@placeholder="Channels…"
    \@groups={{this.channels}}
    \@selectedItems={{this.selectedChannels}}
    \@onChange={{this.onSelectedChannelsChanged}}
  />
  ```

  @class FlyCheckboxDropdown
  @public
 */
let FlyCheckboxDropdown = (_class = class FlyCheckboxDropdown extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "dropdown", null);
  }
  get scrollable() {
    return this.args.scrollable ?? false;
  }
  get disabled() {
    return this.args.disabled ?? false;
  }
  get closeOnDisabledChange() {
    return this.args.closeOnDisabledChange ?? true;
  }
  get isParentDropdownDisabled() {
    if (!isNone(this.dropdown) && !this.closeOnDisabledChange) {
      return false;
    }
    return this.disabled;
  }
  get showLabelForMultipleSelections() {
    if (!(this.args.showLabelForMultipleSelections ?? false)) {
      return false;
    }
    return this.selectedItems.length >= (this.args.showLabelForMultipleSelectionsThreshold ?? 2);
  }
  get selectedItems() {
    let {
      selectedItems
    } = this.args;
    if (this.args.groups) {
      return this.args.groups.reduce((acc, group) => {
        let selectedGroupItems = group.items.filter(item => selectedItems.includes(item.value));
        let isGroupDisplayOnly = isNone(group.displayOnly) ? false : group.displayOnly;
        if (!isGroupDisplayOnly && selectedGroupItems.length === group.items.length) {
          acc = [...acc, group];
        } else {
          acc = [...acc, ...selectedGroupItems];
        }
        return acc;
      }, []);
    }
    return (this.args.items ?? []).filter(item => selectedItems.includes(item.value));
  }

  // We use this to compare the index when looping over selectedItems in the
  // template
  get selectedItemsLengthMinusOne() {
    return this.selectedItems.length - 1;
  }
  get multipleSelectionsLabelText() {
    if (!this.args.showLabelForMultipleSelections || this.selectedItems.length < (this.args.showLabelForMultipleSelectionsThreshold ?? 0)) {
      return;
    }

    // @ts-ignore Pluralize isn't typed correctly in Ember type definitions. TS
    // throws a warning that only 1 argument is expected, but it does support 2.
    return pluralize(this.selectedItems.length, this.args.multipleSelectionsLabel);
  }
  onKeyUp(e) {
    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
    // Escape key should be 'Escape', but according to MDN older versions of IE
    // and Firefox may use 'Esc', so let's check for that too
    if (this.dropdown && (e.key === 'Escape' || e.key === 'Esc')) {
      this.dropdown.actions.close();
      this.dropdown = null;
    }
  }
  onDropdownOpen(dropdown) {
    this.dropdown = dropdown;
    document.addEventListener('keyup', this.onKeyUp);
  }
  onDropdownClose() {
    this.dropdown = null;
    document.removeEventListener('keyup', this.onKeyUp);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDropdownOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDropdownOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDropdownClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDropdownClose"), _class.prototype)), _class);
export { FlyCheckboxDropdown as default };